import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  CONSTANTS,
  getTranslatedText,
} from 'src/components/authentication/contants';
import {BodyLarge} from '@spaced-out/ui-design-system/lib/components/Text';

import css from './password-instruction.css';


const PasswordInstruction = () => {
  const {t} = useLabelTranslation();
  return (
    <div className={css.passwordInstruction}>
      <BodyLarge className={css.instruction}>
        {getTranslatedText(t, CONSTANTS.PASSWORD_INSRUCTION_TEXT)}
      </BodyLarge>
      <div>
        <ul className={css.passwordInformation}>
          <li>
            <BodyLarge className={css.instruction}>
              {getTranslatedText(t, CONSTANTS.PASSWORD_INS_1)}
            </BodyLarge>
          </li>
          <li>
            <BodyLarge className={css.instruction}>
              {getTranslatedText(t, CONSTANTS.PASSWORD_INS_2)}
            </BodyLarge>
          </li>
          <li>
            <BodyLarge className={css.instruction}>
              {getTranslatedText(t, CONSTANTS.PASSWORD_INS_3)}
            </BodyLarge>
          </li>
          <li>
            <BodyLarge className={css.instruction}>
              {getTranslatedText(t, CONSTANTS.PASSWORD_INS_4)}
            </BodyLarge>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PasswordInstruction;
